// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"df4cd371","248":"cd47a696","453":"68693753","528":"873c1eed","626":"9172f0fe","627":"fb41167a","757":"2f66822b","904":"f9e22d3b","938":"413a1db8","947":"04c6f0b0","987":"2151f853"}[chunkId] + ".chunk.js";
};